import { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { useAgencyFeatureFlag } from '../hooks/useAgencyFeatureFlag';
import CGForm from './CGForm';

/**
 * Routeur de bascule entre l'ancien `CGForm` et le nouveau `FormCGIA`.
 *
 * Règles de bascule :
 *  - Si l'URL contient `?registrationId=...` → toujours `CGForm` legacy (mode lecture/édition).
 *  - Sinon, si le feature flag `form_cgia` est activé pour l'agence de l'utilisateur
 *    → redirection vers `/form-cgia` (en conservant la query string).
 *  - Sinon → `CGForm` legacy.
 *
 * Ce composant remplace `<CGForm />` directement dans `main.tsx`, ce qui permet
 * à tous les points d'entrée existants (Header, AgencyHomePage, CGList,
 * AgencyCGList) de continuer à linker vers `/form-cg` sans modification.
 */
const CGFormRouter: FC = () => {
  const location = useLocation();
  const { enabled, isLoading } = useAgencyFeatureFlag('form_cgia');

  const hasRegistrationId = new URLSearchParams(location.search).has('registrationId');

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress sx={{ color: '#FDBB5F' }} />
      </Box>
    );
  }

  if (enabled && !hasRegistrationId) {
    return <Navigate to={`/form-cgia${location.search}`} replace />;
  }

  return <CGForm />;
};

export default CGFormRouter;
